import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { NetworkV2AppDataProviderFactory } from '../factory/NetworkV2AppDataProviderFactory';
import { NetworkV2AppBaseDataProvider } from '../dataProvider/NetworkV2AppBaseDataProvider';

export class NetworkV2AppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: NetworkV2AppDataProviderFactory;
  public dataProvider: NetworkV2AppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new NetworkV2AppDataProviderFactory(),
    });
  }
}
